(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videotideo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoContainers = document.querySelectorAll('[data-video-container]');
  
  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const iframe = container.querySelector('iframe');
    
    if (iframe) {
      // Handle YouTube/Vimeo embeds
      iframe.addEventListener('error', function(e) {
        showError(container, 'Video could not be loaded. Please check the URL.');
      });
      
      // Add loading handler
      iframe.addEventListener('load', function() {
        container.classList.remove('loading');
      });
    }
  });
  
  function showError(container, message) {
    container.innerHTML = `
      <div class="video-error">
        <p>${message}</p>
      </div>
    `;
  }
});

  } catch(e) { console.error(e); }
})();
})();
